import { PayerEvents } from "./events";

/**
 * Maps live event names → growth taxonomy IDs (Untitled growth data doc).
 * Prefer props over renaming events once they are in production.
 */
export const PAYER_EVENT_TAXONOMY: Record<string, string> = {
  // P3 — opened
  [PayerEvents.FLOW_INITIATED]: "P3",
  [PayerEvents.PAYMENT_LINK_OPENED]: "P3",
  [PayerEvents.INVOICE_CONSENT_OPENED]: "P3",
  [PayerEvents.STEP_INVOICE_DETAILS]: "P3",
  [PayerEvents.STEP_CUSTOMER_DETAILS]: "P3",
  [PayerEvents.STEP_PAYMENT_LINK_INTRO]: "P3",
  [PayerEvents.STEP_PAYMENT_LINK_FORM]: "P3",
  [PayerEvents.LANGUAGE_SWITCHED]: "P3",
  [PayerEvents.CONSUMER_PORTAL_INITIATED]: "P3",
  [PayerEvents.CUSTOMER_PORTAL_INITIATED]: "P3",

  // P4 — chose
  [PayerEvents.SELECT_PAYMENT_TYPE]: "P4",
  [PayerEvents.PAYMENT_TYPE_SELECTED]: "P4",
  [PayerEvents.INSTALLMENT_TYPE_SELECTED]: "P4",
  [PayerEvents.PLAN_SELECTED]: "P4",
  [PayerEvents.STEP_PAYMENT_LINK_PLAN]: "P4",
  [PayerEvents.PAYMENT_METHOD_SELECTED]: "P4",
  [PayerEvents.QUANTITY_CHANGED]: "P4",
  [PayerEvents.EARLY_SETTLEMENT_SELECTED]: "P4",

  // P5 — tried
  [PayerEvents.STEP_CARD_PAYMENT]: "P5",
  [PayerEvents.STEP_CARD_PAYMENT_MYFATOORAH]: "P5",
  [PayerEvents.STEP_COMPLETE_PAYMENT]: "P5",
  [PayerEvents.STEP_MANUAL_PAYMENT]: "P5",
  [PayerEvents.STEP_BANK_TRANSFER]: "P5",
  [PayerEvents.STEP_QURRAH]: "P5",
  [PayerEvents.STEP_EARLY_SETTLEMENT]: "P5",
  [PayerEvents.MOYASAR_FORM_LOADED]: "P5",
  [PayerEvents.MOYASAR_PAYMENT_INITIATED]: "P5",
  [PayerEvents.MOYASAR_APPLE_PAY_FAILED]: "P5",
  [PayerEvents.MOYASAR_PAYMENT_ERROR]: "P5",
  [PayerEvents.MYFATOORAH_FORM_LOADED]: "P5",
  [PayerEvents.MYFATOORAH_REDIRECT_FOR_AUTHENTICATION]: "P5",
  [PayerEvents.MYFATOORAH_PAYMENT_FAILED]: "P5",
  [PayerEvents.INTENT_CREATED]: "P5",
  [PayerEvents.INTENT_CREATE_FAILED]: "P5",
  [PayerEvents.PAYMENT_FAILED]: "P5",
  [PayerEvents.BANK_TRANSFER_PROCEED]: "P5",
  [PayerEvents.BANK_SELECTED]: "P5",

  // P6 — paid
  [PayerEvents.MOYASAR_PAYMENT_COMPLETED]: "P6",
  [PayerEvents.MYFATOORAH_PAYMENT_COMPLETED]: "P6",
  [PayerEvents.PAYMENT_SUCCESS]: "P6",
  [PayerEvents.SUBSCRIPTION_AUTO_RENEWAL_SUCCESS]: "P6",

  // P9 — repeats / portal
  [PayerEvents.CONSUMER_HOME_VIEW]: "P9",
  [PayerEvents.CONSUMER_INVOICE_DETAIL]: "P9",
  [PayerEvents.CONSUMER_CARDS_VIEW]: "P9",
  [PayerEvents.CONSUMER_ADD_CARD]: "P9",
  [PayerEvents.CONSUMER_SUBSCRIPTION_CANCEL]: "P9",
  [PayerEvents.CONSUMER_SUBSCRIPTION_PAUSE]: "P9",
  [PayerEvents.CONSUMER_SUBSCRIPTION_UNPAUSE]: "P9",
  [PayerEvents.CUSTOMER_PORTAL_VIEW]: "P9",
  [PayerEvents.CUSTOMER_PORTAL_ACTION]: "P9",
  [PayerEvents.SUBSCRIPTION_AUTO_RENEWAL_FAILED]: "P9",

  // navigation helpers (still tagged for funnel debugging)
  [PayerEvents.STEP_PROCEEDED]: "P4",
  [PayerEvents.STEP_BACK]: "P3",
  [PayerEvents.CUSTOMER_DETAILS_SUBMITTED]: "P4",
  [PayerEvents.CUSTOMER_DETAILS_VALIDATION_FAILED]: "P4",
  [PayerEvents.CUSTOM_FORM_SUBMITTED]: "P4",
  [PayerEvents.CUSTOM_FORM_VALIDATION_FAILED]: "P4",
};
